<template>
    <component :is="view" />
</template>

<script>

import defaultView from './steps/_default.vue';
import lamotteView from './steps/lamotte.vue';

export default {
    name: 'Steps',

    computed: {
        view() {
            if (this.$store.state.application.providerCode === 'lamotte') {
                return lamotteView;
            }

            return defaultView;
        }
    }
};
</script>
